import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentStatusEnum } from '../../common/core/enums/payment-status.enum';
import { ProgressSpinnerService } from '../../components/progress-spinner/progress-spinner.service';
import { lastValueFrom } from 'rxjs';
import { OrdersService } from '../../../api/services/orders.service';

@Component({
  selector: 'rc-payment-order-success',
  templateUrl: './order-callback.component.html',
})
export class OrderCallbackComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly ordersService: OrdersService,
    public progressSpinnerService: ProgressSpinnerService,
  ) {}

  async ngOnInit(): Promise<void> {
    const orderId = this.route.snapshot.queryParamMap.get('orderId');
    if (!orderId) {
      this.router.navigate(['order', 'failed']);
      return;
    }
    this.progressSpinnerService.openProgressSpinner();
    try {
      const order = await lastValueFrom(this.ordersService.ordersControllerConfirmPayment({ key: orderId }));
      switch (order.paymentStatus) {
        case PaymentStatusEnum.PARTIAL:
        case PaymentStatusEnum.COMPLETE:
          this.router.navigate(['order', 'success'], {
            replaceUrl: true,
            queryParams: { orderId: order.orderId },
          });
          break;
        default:
          this.router.navigate(['order', 'failed'], {
            replaceUrl: true,
            queryParams: { cartId: order.shoppingCartId, orderId: order.orderId, pcId: orderId },
          });
          break;
      }
    } catch (error: any) {
      this.router.navigate(['error'], { replaceUrl: true, queryParams: { orderId } });
    }
    this.progressSpinnerService.closeProgressSpinner();
  }
}
